module.exports = __webpack_public_path__ + "static/media/search-no-results.dc169ddd.svg";